const CERTIFIED_ENGINEER_USER_TYPES = new Set([1, 2])

/**
 * @description 判断用户是否为商城代理商。
 * @param {Object|null|undefined} userInfo - 商城用户信息。
 * @returns {boolean} agency=1 时返回 true。
 */
export function isStoreAgencyUser(userInfo) {
  if (!userInfo || typeof userInfo !== 'object') return false
  return Number(userInfo.agency) === 1
}

/**
 * @description 判断是否已从商城用户接口拿到代理商身份字段。
 * @param {Object|null|undefined} userInfo - 商城用户信息。
 * @returns {boolean} agency 字段已返回时为 true。
 */
export function hasStoreAgencyIdentity(userInfo) {
  if (!userInfo || typeof userInfo !== 'object') return false
  return userInfo.agency !== undefined && userInfo.agency !== null
}

/**
 * @description F81：是否允许商城下单。代理商始终允许；工程商/终端客户只看服务端 orderPlacementEnabled（缺字段=不可下单）。
 * @param {Object|null|undefined} userInfo - 商城用户信息。
 * @returns {boolean}
 */
export function canPlaceStoreOrderFromUserInfo(userInfo) {
  if (!userInfo || typeof userInfo !== 'object') return false
  if (isStoreAgencyUser(userInfo)) return true
  return userInfo.orderPlacementEnabled === true
}

/**
 * @description 已拿到商城身份且当前不允许下单时，应拦截并提示。
 * @param {Object|null|undefined} userInfo - 商城用户信息。
 * @returns {boolean}
 */
export function shouldBlockStoreOrderFromUserInfo(userInfo) {
  if (!hasStoreAgencyIdentity(userInfo)) return false
  return !canPlaceStoreOrderFromUserInfo(userInfo)
}

/**
 * @description 判断“工程商认证”入口所需的商城身份字段是否完整。
 * @param {Object|null|undefined} userInfo - 商城用户信息。
 * @returns {boolean} agency 与 userType 均已返回时为 true。
 */
export function hasJoinNavigationIdentity(userInfo) {
  if (!hasStoreAgencyIdentity(userInfo)) return false
  return userInfo.userType !== undefined && userInfo.userType !== null
}

/**
 * @description 判断用户是否为已认证工程商。
 * @param {Object|null|undefined} userInfo - 商城用户信息。
 * @returns {boolean} 企业工程商或已认证个体工程商返回 true。
 */
export function isCertifiedEngineerUser(userInfo) {
  if (!userInfo || typeof userInfo !== 'object') return false
  return CERTIFIED_ENGINEER_USER_TYPES.has(Number(userInfo.userType))
}

/**
 * @description 判断当前用户是否应展示“工程商认证”导航入口。
 * @param {Object|null|undefined} userInfo - 商城用户信息。
 * @returns {boolean} 未入驻用户返回 true，代理商或已认证工程商返回 false。
 */
export function shouldShowJoinNavigation(userInfo) {
  if (!userInfo || typeof userInfo !== 'object') return true

  return !isStoreAgencyUser(userInfo) && !isCertifiedEngineerUser(userInfo)
}
